










































import Vue from 'vue';
import { Message } from 'mycorems-app-shared';
import AsyncBtn from '../components/AsyncBtn.vue';
import { resetPassword } from './password-recovery';

interface Data {
  password: string,
  done: boolean,
  task: Promise<void>|null,
}

export default Vue.extend({
  components: {
    AsyncBtn,
    Message,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      password: '',
      done: false,
      task: null,
    };
  },
  methods: {
    reset() {
      this.task = resetPassword(this.token, this.password);
      this.task.then(() => {
        this.done = true;
      });
    },
  },
});
